function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #c9dfff;\n      }\n\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        opacity: 0.4;\n      }\n\n      .cls-3 {\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 561,
  y: -48,
  width: 135,
  height: 135,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offset",
  dx: 13.856,
  dy: 8,
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 7.55
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#6cb6ff",
  floodOpacity: 0.11
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("image", {
  x: 1218,
  y: 5,
  width: 10,
  height: 13,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAAlElEQVQokYXQsQpBARTG8R9RksFkt5gkkzyIzQvIKo9itti8g0kZxGLyBkYpC4lO3bvc3Hv/8/985zun0ll823jirYAq+tijWyYGI5wxKRODqLDFCo0iMWWOA3plYjDECdMyMWhhgzWaRWLwwQP1WoF0xCz5xt/V9+SgcSoF2cTotMQtO52K1yRll9cjxAsGeOW2xQ9YohfFump0IAAAAABJRU5ErkJggg=="
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1219,11v1H638V11h581Z"
});

var _ref5 = /*#__PURE__*/React.createElement("image", {
  id: "Layer_2_copy",
  "data-name": "Layer 2 copy",
  className: "cls-2",
  y: 5,
  width: 10,
  height: 13,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAAk0lEQVQokYXQMQ4BURCH8Z+1dCIhcQARhRtIUKldxq1EQqHXiCNo9BoKlUJDXrIv2WzW8yVTzMs3mfm/xmD98YcMefZH6mCFXp6QhligHZo6sYkpJuXHqtjFEv3qdFkcYY5W3R15UTOMU6lC6lBvJP8pSmfscE+JkQf2OBXDP8VAWH/BBteUGHnhiAOeMXWKG7bIvzVkFRcLcBjDAAAAAElFTkSuQmCC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Shape_2_copy",
  "data-name": "Shape 2 copy",
  className: "cls-1",
  d: "M9,11v1H590V11H9Z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 614,
  cy: 11,
  r: 11
});

function SvgOverviewDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1228,
    height: 22,
    viewBox: "0 0 1228 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewDivider);
export default __webpack_public_path__ + "static/media/overview-divider.a6aaad1a.svg";
export { ForwardRef as ReactComponent };